import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const createTravelAndLeisureOrderMutation = gql`
  mutation CreateTravelAndLeisureOrder($input: CreateTravelAndLeisureOrderInput!) {
    createTravelAndLeisureOrder(input: $input) {
      createTravelAndLeisureOrder {
        order {
          id
        }
        errors {
          fieldName
          message
        }
      }
    }
  }
`

export const getCreateTravelAndLeisureOrderMutationKey = getQueryNames(createTravelAndLeisureOrderMutation)[0]
export {createTravelAndLeisureOrderMutation}
